/** @format */
import { PleaseWait } from '../../../../../Components/Loaders/PleaseWait'
import Checkbox from '../../../../../Components/Checkbox/Checkbox'
/* eslint-disable */
import React from 'react'

export const AuthorizedBranchesOperationsACL = ({
  branchesToBeSelected,
  isBusy,
  onCheckBranch,
  prefix,
  disabled,
}) => {
  const handleCheckBranches = (branch, checkValue) => {
    const com = [...branchesToBeSelected].map(comm => {
      if (comm.id === branch.id) {
        return { ...comm, checked: checkValue }
      }
      return comm
    })
    onCheckBranch(checkValue, com, branch)
  }

  return (
    <div className="px-4">
      {isBusy ? (
        <PleaseWait />
      ) : (
        <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
          {branchesToBeSelected?.map(branch => (
            <li
              key={branch.id}
              style={{ listStyle: 'none' }}
              className=" d-flex align-items-center"
            >
              <Checkbox
                id={`${prefix ? prefix : 'com'}-${branch.id}`}
                checked={branch.checked}
                disabled={disabled}
                margined
                onCheck={c => {
                  handleCheckBranches(branch, c)
                }}
              />
              <label
                htmlFor={`${prefix ? prefix : 'com'}-${branch.id}`}
                className={`fw-normal ms-2 cursor-pointer ${
                  branch.checked ? 'text-primary fw-bold' : ''
                }`}
              >
                {branch.description}
              </label>
            </li>
          ))}
        </div>
      )}
    </div>
  )
}
